module.exports = __webpack_public_path__ + "static/media/ipoa3.364d58ec.jpg";